import PropTypes from 'prop-types'

function FormFieldLabel({
  name,
  children,
}) {
  return (
    <label
      htmlFor={name}
      className="block text-sm font-medium text-gray-700 mb-2"
    >
      {children}
    </label>
  )
}

FormFieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
}

export default FormFieldLabel
